import { useEffect } from 'react'

import { parseDate } from './parsing'

// Update selectedDate when value changes
export function useValueEffect(
  value: string,
  includeTime: boolean,
  monthYearOnly: boolean,
  setSelectedDate: React.Dispatch<React.SetStateAction<Date | null>>,
  setCurrentMonth: React.Dispatch<React.SetStateAction<number>>,
  setCurrentYear: React.Dispatch<React.SetStateAction<number>>,
  setSelectedMonth: React.Dispatch<React.SetStateAction<number | null>>,
  setSelectedYear: React.Dispatch<React.SetStateAction<number | null>>,
  setSelectedTime: React.Dispatch<React.SetStateAction<{ hours: number; minutes: number }>>
) {
  useEffect(() => {
    const parsed = parseDate(value, monthYearOnly, includeTime)
    if (parsed) {
      setSelectedDate(parsed)
      setCurrentMonth(parsed.getMonth())
      setCurrentYear(parsed.getFullYear())
      if (monthYearOnly) {
        setSelectedMonth(parsed.getMonth())
        setSelectedYear(parsed.getFullYear())
      }
      if (includeTime) {
        setSelectedTime({ hours: parsed.getHours(), minutes: parsed.getMinutes() })
      }
    } else {
      // If value is invalid or not set, reset to current date
      const now = new Date()
      setCurrentMonth(now.getMonth())
      setCurrentYear(now.getFullYear())
      if (monthYearOnly) {
        setSelectedMonth(null)
        setSelectedYear(null)
      }
      if (includeTime) {
        // Always set to current time when opening picker for timestamp fields with no value
        const currentTime = { hours: now.getHours(), minutes: now.getMinutes() }
        setSelectedTime(currentTime)
        // Also set selectedDate to today with current time for better UX
        const todayWithTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), currentTime.hours, currentTime.minutes)
        setSelectedDate(todayWithTime)
      } else {
        setSelectedDate(null)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, includeTime, monthYearOnly]) // setState functions are stable and don't need to be in dependencies
}
